<id37-modal-backdrop></id37-modal-backdrop>

<id37-modal-dialog [ngClass]="{
  'small-mobile': modalSize === 'small-mobile',
  'small': modalSize === 'small' || modalSize === 'sm',
  'large': modalSize === 'large' || modalSize === 'lg'
}">
  <ng-content></ng-content>
</id37-modal-dialog>
